export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '94c0b34', dateTime: 1774648095804 };